import { render, staticRenderFns } from "./ProductionsCosts.vue?vue&type=template&id=6ee587ff&lang=pug"
import script from "./ProductionsCosts.vue?vue&type=script&lang=js"
export * from "./ProductionsCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports